import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const KinKeeperRegister = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${config.API_BASE_URL}/kinkeeper/register`, {
        firstName,
        lastName,
        email,
        password
      });

      localStorage.removeItem("elderID");
      localStorage.removeItem("patientID");
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("kinkeeperID", response.data.kinkeeperID);
      navigate("/elders/new");
    } catch (err) {
      if (err.response?.status === 409) {
        setError(t("kinKeeperRegister.emailTaken"));
      } else {
        setError(err.response?.data?.error || t("kinKeeperRegister.failed"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <section className="page-panel">
        <div className="page-content auth-layout">
          <div className="support-card">
            <div>
              <div className="intro-badge">{t("kinKeeperRegister.badge")}</div>
              <h1 className="page-title">{t("kinKeeperRegister.title")}</h1>
              <p className="page-subtitle">
                {t("kinKeeperRegister.subtitle")}
              </p>
            </div>

            <div className="support-list">
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("kinKeeperRegister.support1Title")}</div>
                  <p>{t("kinKeeperRegister.support1Text")}</p>
                </div>
              </div>
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("kinKeeperRegister.support2Title")}</div>
                  <p>{t("kinKeeperRegister.support2Text")}</p>
                </div>
              </div>
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("kinKeeperRegister.support3Title")}</div>
                  <p>{t("kinKeeperRegister.support3Text")}</p>
                </div>
              </div>
            </div>
          </div>

          <form className="form-card" onSubmit={handleRegister}>
            <div className="form-header">
              <h2>{t("kinKeeperRegister.formTitle")}</h2>
              <p>{t("kinKeeperRegister.formSubtitle")}</p>
            </div>

            {error && <div className="error-banner">{error}</div>}

            <div className="form-grid">
              <div className="form-field">
                <label htmlFor="first-name">{t("kinKeeperRegister.firstNameLabel")}</label>
                <input
                  id="first-name"
                  className="text-input"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                  placeholder={t("kinKeeperRegister.firstNamePlaceholder")}
                />
              </div>

              <div className="form-field">
                <label htmlFor="last-name">{t("kinKeeperRegister.lastNameLabel")}</label>
                <input
                  id="last-name"
                  className="text-input"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                  placeholder={t("kinKeeperRegister.lastNamePlaceholder")}
                />
              </div>

              <div className="form-field full">
                <label htmlFor="register-email">{t("kinKeeperRegister.emailLabel")}</label>
                <input
                  id="register-email"
                  className="text-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder={t("kinKeeperRegister.emailPlaceholder")}
                />
              </div>

              <div className="form-field full">
                <label htmlFor="register-password">{t("kinKeeperRegister.passwordLabel")}</label>
                <div style={{ position: "relative" }}>
                  <input
                    id="register-password"
                    className="text-input"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder={t("kinKeeperRegister.passwordPlaceholder")}
                    style={{ paddingRight: "3.5rem" }}
                  />
                  <button
                    type="button"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "0.9rem",
                      top: "50%",
                      transform: "translateY(-50%)",
                      border: "none",
                      background: "transparent",
                      color: "#5f6c76",
                      minHeight: "auto",
                      padding: 0
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
            </div>

            <div className="button-row">
              <button className="button" type="submit" disabled={loading}>
                {loading ? t("kinKeeperRegister.submitting") : t("kinKeeperRegister.submit")}
              </button>
            </div>

            <p className="simple-note">
              {t("kinKeeperRegister.hasAccount")}{" "}
              <button
                type="button"
                className="simple-link"
                style={{ border: "none", background: "transparent", padding: 0 }}
                onClick={() => navigate("/login")}
              >
                {t("kinKeeperRegister.loginLink")}
              </button>
            </p>
          </form>
        </div>
      </section>
    </div>
  );
};

export default KinKeeperRegister;
